import { cn, Icon } from '@mntn/ui-components'
import { type ComponentPropsWithoutRef, forwardRef } from 'react'

interface AllocationStatusBadgeProps extends Omit<ComponentPropsWithoutRef<'div'>, 'children'> {
  status: 'allocated' | 'warning'
  borderClassName?: string
}

export const AllocationStatusBadge = forwardRef<HTMLDivElement, AllocationStatusBadgeProps>(
  ({ status, className, borderClassName, ...rest }, ref) => {
    const isAllocated = status === 'allocated'

    return (
      <div ref={ref} className={cn('border-glass p-[1px] rounded-full', borderClassName)} {...rest}>
        <div
          className={cn(
            'rounded-full p-[10px] flex items-center justify-center',
            isAllocated ? 'bg-secondary-accent-inverse' : 'bg-warning',
            className,
          )}
        >
          <Icon
            name={isAllocated ? 'Check' : 'TriangleAlert'}
            className={cn('size-[16px]', isAllocated ? 'text-background-inverse' : 'text-header')}
          />
        </div>
      </div>
    )
  },
)

AllocationStatusBadge.displayName = 'AllocationStatusBadge'
